module.exports = __webpack_public_path__ + "static/media/logo-fabiana-carvalho-preto.5f5a6965.png";